<div>
  <div class="container-fluid">
    <!-- Page Header -->
    <div class="page-header mb-4">
      <h1 class="h2 mb-1 fw-bold">Admin Dashboard</h1>
      <p class="text-secondary mb-0">Welcome to the American Drone Network Administration Portal</p>
    </div>

    <!-- Summary Stats Row -->
    <div class="row g-3 mb-4">
      <div class="col-12 col-md-6 col-lg-3">
        <div class="card stat-card h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="text-secondary mb-1">Total Users</p>
                <h2 class="stat-value mb-0">
                  <span *ngIf="statsLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span *ngIf="!statsLoading">{{ totalUsers }}</span>
                </h2>
              </div>
              <i class="bi bi-people stat-icon bg-primary bg-opacity-10 text-primary"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <div class="card stat-card h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="text-secondary mb-1">Active Drones</p>
                <h2 class="stat-value mb-0">
                  <span *ngIf="statsLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span *ngIf="!statsLoading">{{ activeDrones }}</span>
                </h2>
              </div>
              <i class="bi bi-box-seam stat-icon bg-primary bg-opacity-10 text-primary"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <div class="card stat-card h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="text-secondary mb-1">Support Tickets</p>
                <h2 class="stat-value mb-0">
                  <span *ngIf="statsLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span *ngIf="!statsLoading">{{ openTickets }}</span>
                </h2>
              </div>
              <i class="bi bi-life-preserver stat-icon bg-primary bg-opacity-10 text-primary"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <div class="card stat-card h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="text-secondary mb-1">Active Organizations</p>
                <h2 class="stat-value mb-0">
                  <span *ngIf="statsLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span *ngIf="!statsLoading">{{ activeOrganizations }}</span>
                </h2>
              </div>
              <i class="bi bi-building stat-icon bg-primary bg-opacity-10 text-primary"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Access -->
    <div class="row g-3 mb-4">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/users" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-people"></i>
            </div>
            <div>
              <h6 class="mb-1">Users</h6>
              <p class="text-secondary small mb-0">Manage accounts &amp; roles</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/organizations" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-building"></i>
            </div>
            <div>
              <h6 class="mb-1">Organizations</h6>
              <p class="text-secondary small mb-0">Teams, members &amp; settings</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/drones" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-box-seam"></i>
            </div>
            <div>
              <h6 class="mb-1">Drone Inventory</h6>
              <p class="text-secondary small mb-0">ADN fleet &amp; assignments</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/flight-records" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-journal-text"></i>
            </div>
            <div>
              <h6 class="mb-1">Flight Records</h6>
              <p class="text-secondary small mb-0">Spray records across all orgs</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/chemicals" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-droplet"></i>
            </div>
            <div>
              <h6 class="mb-1">Chemicals</h6>
              <p class="text-secondary small mb-0">Acre Advantage products</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/sponsors" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-award"></i>
            </div>
            <div>
              <h6 class="mb-1">Sponsors</h6>
              <p class="text-secondary small mb-0">Partners, rates &amp; locations</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/faa-reports" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-file-text"></i>
            </div>
            <div>
              <h6 class="mb-1">FAA Reports</h6>
              <p class="text-secondary small mb-0">Generate &amp; manage reports</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <a routerLink="/support/unassigned-tickets" class="card stat-card h-100 text-decoration-none">
          <div class="card-body d-flex align-items-start gap-3 py-3">
            <div class="entity-avatar entity-avatar-lg entity-avatar-square">
              <i class="bi bi-life-preserver"></i>
            </div>
            <div>
              <h6 class="mb-1">Unassigned Tickets</h6>
              <p class="text-secondary small mb-0">Route tickets to orgs</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Coming Soon -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center py-4">
            <i class="bi bi-cone-striped fs-2 text-warning me-2"></i>
            <span class="fw-semibold me-3">Coming Soon</span>
            <span class="text-secondary small">
              <span class="badge text-bg-secondary me-1">Replacements</span>
              <span class="badge text-bg-secondary me-1">Maintenance</span>
              <span class="badge text-bg-secondary me-1">Support Tickets</span>
              <span class="badge text-bg-secondary me-1">Orders</span>
              <span class="badge text-bg-secondary me-1">Analytics</span>
              <span class="badge text-bg-secondary">System Logs</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
